import { Button, TextField } from '@cimpress/react-components';
import { useState } from 'react';
import { useUpdateEffect } from '../../../tools';
import { Control } from '../../layout';
import type { BrandColor } from './types';
import { isValidColorState } from './isValidColorState';
import { ColorInput } from './ColorInput';

export interface BrandColorEditorProps {
    assetId: string;
    initialValue?: BrandColor;
    onChange: (assetId: string, value: BrandColor) => void;
    onRemove: (assetId: string) => void;
}

interface ColorState {
    color: string;
    isValid: boolean;
    context?: string;
}

function assetToState(brandColor?: BrandColor): ColorState {
    if (!brandColor) {
        return {
            color: '',
            isValid: isValidColorState(''),
        };
    }

    const { color, context } = brandColor;

    return {
        color: color ?? '',
        context: context,
        isValid: isValidColorState(color ?? ''),
    };
}

export const BrandColorAssetEditor = ({ assetId, initialValue, onChange, onRemove }: BrandColorEditorProps) => {
    const [brandColor, setBrandColor] = useState(() => assetToState(initialValue));

    const { color, context, isValid } = brandColor;

    useUpdateEffect(() => {
        if (isValid) {
            onChange(assetId, {
                color,
                context,
            });
        }
    }, [assetId, color, context, isValid, onChange]);

    return (
        <Control spacing="compact">
            <ColorInput
                label="Color"
                value={color}
                isValid={isValid}
                onChange={(value, isValid) => setBrandColor((prev) => ({ ...prev, color: value, isValid }))}
            />
            <TextField
                label="Context (Optional)"
                required={false}
                value={context}
                onChange={(e) => setBrandColor((prev) => ({ ...prev, context: e.target.value }))}
            />
            <Button color="danger" aria-label="Remove color" onClick={() => onRemove(assetId)}>
                Remove Color
            </Button>
        </Control>
    );
};
